/**
 * Copy for the FreeFortifyPanel, centralised so the two contexts it renders in
 * (a normal post-conquest transfer during the attack phase, and the FIRST step
 * of the post-elimination interrupt) read correctly and can be unit-tested.
 *
 * The post-elim flow is the important one: the player has just eliminated a
 * player, and the free fortify happens BEFORE they place their elimination
 * bonus. The instruction line spells that ordering out so it doesn't look like
 * the fortify is the whole reward.
 *
 * `bonusArmiesAfter` is the number of bonus armies waiting to be placed once
 * the fortify window closes (0/undefined in the normal attack-phase case).
 */
export interface FreeFortifyCopy {
  /**
   * Sentence ending appended directly after "…into your new territory".
   * Includes its own leading space + terminating period, so callers render
   * `into your new territory{trailing}` with no extra punctuation.
   */
  trailing: string
  /** Label for the transfer-zero ("skip") button. */
  skipLabel: string
}

export function freeFortifyCopy(bonusArmiesAfter?: number): FreeFortifyCopy {
  const pending = bonusArmiesAfter ?? 0
  if (pending > 0) {
    return {
      trailing: ' before you place your elimination bonus armies.',
      skipLabel: 'Skip to placement',
    }
  }
  return {
    trailing: '.',
    skipLabel: 'Skip',
  }
}
